import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BotMessageListFn,
  DeleteBotMessageListFn,
  DeleteUnmatchedListFn,
  PatchBotMessageListFn,
  UnmatchedListFn,
} from "../../../Services/ChatAgent";
import {
  Button,
  Divider,
  IconButton,
  Pagination,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMutation, useQuery } from "react-query";
import { EditIcon } from "lucide-react";
import { toast } from "react-toastify";
import { Delete, Edit } from "@mui/icons-material";

const UnMatchedSearch = () => {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);

  const [initialValues, setInitialValue] = useState(null);

  const [search, setSearch] = useState("");

  const { data, isLoading, refetch } = useQuery(
    ["unmatched", search, page],
    () =>
      UnmatchedListFn({
        store_id: localStorage.getItem("store_id"),
        search,
        page,
      }),
  );

  const AgentQA = data?.data?.data || [];

  const { mutate: DeleteQa } = useMutation(DeleteUnmatchedListFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        refetch();
      } else {
        toast.warn(res?.data?.message);
      }
    },
  });

  //   const { mutate: UpdateQa, isLoading: UpdateLoading } = useMutation(
  //     PatchBotMessageListFn,
  //     {
  //       onSuccess: (res) => {
  //         if (res?.data?.response_code === 200) {
  //           toast.success(res?.data?.message);

  //           refetch();
  //         } else {
  //           toast.warn(res?.data?.message);
  //         }
  //       },
  //     }
  //   );

  if (isLoading) {
    return <p className="text-center p-4">Loading...</p>;
  }

  return (
    <div className=" w-full">
      {" "}
      <div className="w-full p-4 rounded-lg border bg-deepBlue  border-gray-300 ">
        <div className="flex items-center p-2 h-14  border-zinc-600  justify-between">
          <input
            type="text"
            value={search}
            className="!border-3 !border-black !w-64 px-2 rounded-md py-1"
            placeholder="search"
            style={{ border: "1px solid black" }}
            onChange={(event) => setSearch(event.target.value)}
          />

          {/* <AddChatBotMessages
            initialValues={initialValues}
            setInitialValue={setInitialValue}
            refetch={refetch}
          /> */}
        </div>
        <Divider />
        <div className="w-full overflow-auto ">
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 440,
              backgroundColor: "transparent",
              overflowX: "auto",
            }}
            className="!bg-transparent"
          >
            <Table
              size="small"
              stickyHeader
              sx={{ backgroundColor: "transparent" }}
            >
              <TableHead sx={{ backgroundColor: "#2b0175" }}>
                <TableRow sx={{ backgroundColor: "#2b0175" }}>
                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#2b0175",
                    }}
                  >
                    #
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#2b0175",
                    }}
                  >
                    Questions
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#2b0175",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="!overflow-y-auto !vh-[100%]">
                {AgentQA &&
                  AgentQA?.map((row, index) => (
                    <TableRow
                      //   sx={{
                      //     "&:last-child td, &:last-child th": { border: 0 },
                      //   }}

                      sx={{ color: "#000000" }}
                    >
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "transparent",

                          borderRight: "1px solid #D0D0D0",
                        }}
                        className="text-xs"
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "transparent",

                          borderRight: "1px solid #D0D0D0",
                        }}
                        className="text-xs"
                      >
                        {row?.question || "--"}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "transparent",

                          borderRight: "1px solid #D0D0D0",
                        }}
                        className="text-xs"
                      >
                        <IconButton
                          onClick={() =>
                            DeleteQa({ unmatched_question_id: row?.id })
                          }
                        >
                          <Delete color="error" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <div className="flex items-center justify-center p-2">
            <Pagination
              variant="outlined"
              page={data?.data?.current_page ?? 1}
              count={data?.data?.total_pages ?? 1}
              onChange={(_, val) => setPage(val)}
            />{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnMatchedSearch;
